<template>
<v-container>
  <h2><v-icon class="mr-3" color="yellow">mdi-star</v-icon>Classement</h2>
  <v-progress-circular
  v-if="loading"
      indeterminate
      color="teal darken-2"
    ></v-progress-circular>
    <p v-if="ranking">Généré le {{ new Date(ranking.date).toLocaleDateString() }} à {{ new Date(ranking.date).toLocaleTimeString() }}  </p>
<v-simple-table fixed-header height="300px" v-if="ranking">
  <thead>
         <tr>
           <th class="text-left">Classement</th>
           <th class="text-left">Pseudo</th>
           <th class="text-left">Score</th>
           <th class="text-left">Validations</th>
         </tr>
       </thead>
       <tbody>
       <tr :class="currentUser(item.uid)" v-for="(item,i) in ranking.data" :key="i">
         <td>{{ i + 1 }}</td>
         <td class="text-center">{{ item.player }}</td>
         <td class="text-center">{{ item.score }}</td>
         <td class="text-center">{{ item.v }}</td>
       </tr>
     </tbody>
</v-simple-table>
</v-container>

</template>
<script>
import firebase from '@firebase/app';
import   '@firebase/firestore';

export default {
  data: () => ({
    ranking: null,
    loading: false
  }),
  methods: {
    currentUser(uid){

      if (this.$store.getters.user && uid == this.$store.getters.user.data.uid) {
        return 'font-weight-bold';
      } else {
        return '';
      }
    }
  },
  mounted() {
    this.loading = true;
  const firestore = firebase.firestore();
  firestore.collection('rankings').doc('ranking').get().then(d => {
    this.loading = false;
    this.ranking = d.data();
  }).catch(() => {
    this.loading = false;
  })
  }

}

</script>
